var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('v-row',{staticClass:"fill-height loginBackground",attrs:{"align":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"8","md":"6","offset-sm":"2","offset-md":"3","align":"center"}},[_c('v-card',{attrs:{"max-width":"600","elevation":"0","rounded":"xxl","color":"background"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }